// extracted by mini-css-extract-plugin
export default {"main":"PetSelector_main__VPejy"};